import './public-path'
import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import './modules/fptai/filters/filters'
// plugin
import i18n from './plugins/i18n'
import './plugins/vuetify'
import './plugins/sentry'
import './plugins/vue-cookies'
import './plugins/axios'
import './plugins/moment'
import './plugins/vue-notification'
import './plugins/vue-modal'
import './plugins/lodash'
import 'chartjs-plugin-datalabels'
// theme
import './assets/stylus/main.styl'
// app included
import '@/utils/utils'
import '@/utils/const'
import '@/store/actionTypes'
import '@/eventbus/appservice.eventbus'
import '@/services/app.service'
// style
import '@/modules/fptai/assets/css/fci-class.scss'

import AuthService from '@/services/auth.service'

Vue.config.productionTip = false

AuthService.initCrossTabSync()

window.vueapp = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
